import request from '@/helpers/customAxios'
// 公共的业务函数
interface CheckParam {
    [key: string]: string
}
export async function reqSameNameCheck(param: {
    name: string
    dirId: string
    fileType?: 'dir' | 'file'
    uuid?: string
}): Promise<{
    code: number
    data: any
    desc: string
}> {
    // 上传，移动,复制,检查文件重名
    const { name, dirId, fileType, uuid } = param
    let reqUrl = '/api/checkFile'
    if (typeof uuid !== 'undefined') {
        reqUrl = `/common/checkFile/${uuid}`
    }
    const params: CheckParam = { name, dirId }
    if (typeof fileType !== 'undefined') {
        params.fileType = fileType
    }
    if (typeof uuid !== 'undefined') {
        params.uuid = uuid
    }
    let res
    try {
        res = await request.get(reqUrl, { params })
    } catch (e) {
        res = {
            code: 1,
            desc: '检查文件出错',
        }
    }
    return res
}
import { MessageBox, Message } from 'element-ui'
import { SameFileType, IFileItem } from './public'
import { ErrorCode } from '@/constant'
import { FilePathName } from '@/helpers/common'
export function renameDialog(newFileName: string, fileType: '文件夹' | '文件'): Promise<boolean> {
    return new Promise((resolve, reject) => {
        MessageBox.confirm(`系统将${fileType}更名为${newFileName},是否继续执行该操作`, `当前路径存在相同${fileType}`, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                resolve(true)
            })
            .catch(() => {
                resolve(false)
            })
    })
}

export function checkName(distMd5: string, originMd5: string) {
    let sameType
    if (distMd5 === originMd5) {
        sameType = SameFileType.SAME_MD5
    } else {
        sameType = SameFileType.SAME_NAME
    }
    return sameType
}
export enum RenameType {
    'SUCESS' = 0,
    'CANCEL' = 1,
    'ERROR' = 2,
}
export async function handleSameName(src: IFileItem, target: IFileItem): Promise<RenameType> {
    const res = await reqSameNameCheck({
        name: src.name,
        dirId: target.id,
        fileType: src.isFile ? 'file' : 'dir',
    })
    if (!res || res.code !== 0) {
        const eMsg = res && res.desc ? res.desc : '重名校验失败'
        Message.error(eMsg)
        return RenameType.ERROR
    }
    const fileTypeName = src.isFile ? '文件' : '文件夹'
    let nextStep = RenameType.SUCESS
    if (res.data !== null) {
        nextStep = (await renameDialog(res.data.rename, fileTypeName)) === true ? RenameType.SUCESS : RenameType.CANCEL
    }

    return nextStep
}

export async function desktopUploadHandler(currentDirId: string, shareIdentify?: string) {
    console.log('上传请求客户端')
    if (!window || !(window as any).Ait || !(window as any).Ait.fileSystem) {
        Message.error('环境变量导入失败，请重试')
        return
    }
    if (!currentDirId) {
        return
    }

    const res = await (window as any).Ait.fileSystem.selectFiles({
        dirId: currentDirId,
        shareIdentify,
    })
    if (res.code === ErrorCode.NO_LOGIN) {
        window.location.reload()
        return
    }
    // } else {
    //   // Message.error(res.message || "上传失败");
    // }
    // } else {
    if (!res.data) {
        return
    }
    const resData = res.data
    // if (resData.failedFile && resData.failedFile.length !== 0) {
    //   // const filesName = res.data.failedFile.join();
    //   // Message.error(`${filesName} 上传失败`);
    // }
    let toastMsg = true
    // 处理同名但MD5值不同的文件
    if (resData.sameNameFileMap && Object.keys(resData.sameNameFileMap).length > 0) {
        const samePathNameMap = resData.sameNameFileMap
        for (let path in samePathNameMap) {
            if (!samePathNameMap[path]) {
                Message.error(`上传路径为${path}的文件重名，请重试`)
                continue
            }
            try {
                await MessageBox.confirm(
                    `系统将上传文件更名为${samePathNameMap[path]},是否继续执行该操作`, // todo
                    '当前路径存在相同文件名',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                )
                const retryMap = { [path]: samePathNameMap[path] }
                await desktopRetryUpload(currentDirId, retryMap)
            } catch (e) {
                console.log('cancel upload ccc')
                toastMsg = false
            }
        }
    }
    if (
        resData.selected &&
        resData.selected.length !== 0 &&
        resData.failedFile &&
        resData.failedFile.length < resData.selected.length &&
        toastMsg
    ) {
        Message.success('开始上传，前往上传中列表查看')
    }
}
export async function desktopRetryUpload(currentDirId: string, retryMap: FilePathName, shareIdentify?: string) {
    if (!window || !(window as any).Ait || !(window as any).Ait.fileSystem) {
        Message.error('环境变量导入失败，请重试')
        return
    }
    //这里是单个文件
    if (!Object.keys(retryMap).length || !currentDirId) {
        return
    }
    const res = await (window as any).Ait.fileSystem.retrySameNameUpload({
        dirId: currentDirId,
        sameFileRetry: retryMap,
        shareIdentify,
    })
    if (!res || res.code !== 0) {
        if (res.code === ErrorCode.NO_LOGIN) {
            window.location.reload()
            return
        }
        return
    }

    // } else {
    //   // Message.error(res.message || "上传失败");
    // }
    // } else {
    if (!res.data || (res.data.failedFile && res.data.failedFile.length > 0)) {
        Message.error('重命名后上传失败，请重试')
        return
    }
    // const resData = res.data;
    // if (resData.failedFile && resData.failedFile.length !== 0) {
    //   // const filesName = res.data.failedFile.join();
    //   // Message.error(`${filesName} 上传失败`);
    // }
}
export async function dragUploadHandler(currentDirId: string, filePath: string[], shareIdentify?: string) {
    if (!window || !(window as any).Ait || !(window as any).Ait.fileSystem) {
        Message.error('环境变量导入失败，请重试')
        return
    }
    console.log('拖拽上传请求客户端')
    const res = await (window as any).Ait.fileSystem.uploadDragFile({
        dirId: currentDirId,
        filePath,
        shareIdentify,
    })
    if (!res || res.code !== 0) {
        if (res.code === ErrorCode.NO_LOGIN) {
            window.location.reload()
            return
        }
        return
    }
    //   if (res.code === ErrorCode.NO_LOGIN) {
    //     window.location.reload();
    //     return;
    //   }
    if (!res.data) {
        return
    }
    const resData = res.data
    let toastMsg = true
    // 处理同名但MD5值不同的文件
    if (resData.sameNameFileMap && Object.keys(resData.sameNameFileMap).length > 0) {
        const samePathNameMap = resData.sameNameFileMap
        for (let path in samePathNameMap) {
            if (!samePathNameMap[path]) {
                Message.error(`上传路径为${path}的文件重名，请重试`)
                continue
            }
            try {
                await MessageBox.confirm(
                    `系统将上传文件更名为${samePathNameMap[path]},是否继续执行该操作`, // todo
                    '当前路径存在相同文件名',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                )
                const retryMap = { [path]: samePathNameMap[path] }
                await desktopRetryUpload(currentDirId, retryMap)
            } catch (e) {
                console.log('cancel upload')
                toastMsg = false
            }
        }
    }
    if (
        resData.selected &&
        resData.selected.length !== 0 &&
        resData.failedFile &&
        resData.failedFile.length < resData.selected.length &&
        !shareIdentify &&
        toastMsg
    ) {
        Message.success('开始上传，前往上传中列表查看')
    }
}
